module.exports = __webpack_public_path__ + "img/service-providers-icon.c27f1df3.png";